import type React from 'react';
import { createContext, type PropsWithChildren, useContext, useState } from 'react';

export interface AccessPointContextType {
  isAuthorizedToAccessPoint: boolean;
  setIsAuthorizedToAccessPoint: React.Dispatch<React.SetStateAction<boolean>>;
  setApAuthError: React.Dispatch<React.SetStateAction<string | undefined>>;
  apAuthError: string | undefined;
  isAuthorizationRequestSuccess: boolean;
  setIsAuthorizationRequestSuccess: React.Dispatch<React.SetStateAction<boolean>>;
  isWaitingForAuthStatus: boolean;
  setIsWaitingForAuthStatus: React.Dispatch<React.SetStateAction<boolean>>;
  isStartAuthorizingToAP: boolean;
  setIsStartAuthorizingToAP: React.Dispatch<React.SetStateAction<boolean>>;
}

const AccessPointContext = createContext<AccessPointContextType | undefined>(undefined);

export const useAccessPoint = () => {
  const context = useContext(AccessPointContext);
  if (!context) {
    throw new Error('useAccessPoint must be used within an AccessPointProvider');
  }
  return context;
};

export const AccessPointContextProvider = ({ children }: PropsWithChildren) => {
  const [isAuthorizedToAccessPoint, setIsAuthorizedToAccessPoint] = useState(false);
  const [isAuthorizationRequestSuccess, setIsAuthorizationRequestSuccess] = useState(false);
  const [isStartAuthorizingToAP, setIsStartAuthorizingToAP] = useState(true);
  const [isWaitingForAuthStatus, setIsWaitingForAuthStatus] = useState(false);
  const [apAuthError, setApAuthError] = useState<string | undefined>(undefined);
  return (
    <AccessPointContext.Provider
      value={{
        isAuthorizationRequestSuccess,
        isAuthorizedToAccessPoint,
        setIsAuthorizedToAccessPoint,
        setIsAuthorizationRequestSuccess,
        setIsWaitingForAuthStatus,
        isWaitingForAuthStatus,
        apAuthError,
        setApAuthError,
        isStartAuthorizingToAP,
        setIsStartAuthorizingToAP,
      }}
    >
      {children}
    </AccessPointContext.Provider>
  );
};
